import React, { useState } from 'react';

import TeamSelectorContainer from '../Shared/Filters/TeamsSelector';
import { isCC, isNCAA, isNCAAAllSports, isTA } from '../../helpers';
import { YearSeasonFilter } from '../Shared/Filters/YearSeasonFilter/YearSeasonFilter';
import { FILTER_KEYS, SIMPLE_LEAGUE } from '../../config/constants';
import SimpleSelector from '../Shared/Filters/SimpleSelector';
import { User } from '../../config/commonTypes';
import { useFiltersState } from 'store/hooks';
import { useRouter } from 'helpers/customHooks';

export default ({ user }: { user: User }) => {

  const [showFilter, setShowFilter] = useState(-1);
  const { specificScope} = useRouter();
  const {[FILTER_KEYS.DATE_RANGE]: year} = useFiltersState(specificScope, FILTER_KEYS.TEAM_ID, FILTER_KEYS.DATE_RANGE);
  const defaultYear = year?.year;

  const close = () => setShowFilter(-1);
  const currentDate = new Date();

  return (
    <div className="head-filters-01">
      {isCC(user) && (
        <SimpleSelector
          close={close}
          show={showFilter === 0}
          open={() => setShowFilter(0)}
          type={SIMPLE_LEAGUE}
          urlPersistent
        />
      )}
      {((user.league === 'ncaa-mlax' && !isTA(user)) || (user.league !== 'ncaa-mlax' && user.league !== 'ncaa-fbs')) && (
        <TeamSelectorContainer
          show={showFilter === 1}
          close={close}
          open={() => setShowFilter(1)}
          urlPersistent
        />
      )}
      {/*<DateRangeSelector*/}
      {/*  loadData={loadGames}*/}
      {/*  show={showFilter === 2} close={close} open={() => setShowFilter(2)}*/}
      {/*/>*/}
      <YearSeasonFilter
        show={showFilter === 3}
        close={close}
        open={() => setShowFilter(3)}
        // [january, august]  should display a past year, [september, december, january, fecbruary] should shown a current year
        defaultYear={currentDate.getMonth() <= 7 ? currentDate.getFullYear() - 1 : currentDate.getFullYear()}
        onlySeasonWeeks
        isNcaa={isNCAAAllSports(user) || isNCAA(user)}
        urlPersistent
      />
    </div>
  );
};
